import { gsap } from "gsap";

class InfoModal {
	constructor() {
		this.modal = document.querySelector("[data-info-modal]");
	}

	init() {
		if (!this.modal) return;

		this._headline = this.modal.querySelector("[data-info-modal-headline]");
		this._permalink = this.modal.querySelector("[data-info-modal-permalink]");
		this._body = this.modal.querySelector("[data-info-modal-body]");
		this._buttons = this.modal.querySelector("[data-info-modal-buttons]");
		this._photo = this.modal.querySelector("[data-info-modal-photo]");

		// Move to body so it's never clipped by an ancestor's overflow:hidden
		document.body.appendChild(this.modal);

		this.modal.querySelectorAll("[data-info-modal-close]").forEach((el) => {
			el.addEventListener("click", () => this.close());
		});

		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") this.close();
		});
	}

	open(data) {
		if (!this.modal) return;

		this._headline.textContent = data.title || "";

		if (data.permalink) {
			this._permalink.href = data.permalink;
			this._permalink.style.display = "";
		} else {
			this._permalink.style.display = "none";
		}

		this._body.innerHTML = data.copy || "";
		this._body.style.display = data.copy ? "" : "none";

		this._buttons.innerHTML = "";
		(data.links || []).forEach((link) => {
			if (!link.url) return;
			const a = document.createElement("a");
			a.href = link.url;
			a.textContent = link.title || link.url;
			if (link.target) a.target = link.target;
			a.className =
				"info-modal__btn" +
				(link.style === "outlined" ? " info-modal__btn--outlined" : "");
			this._buttons.appendChild(a);
		});

		if (data.image) {
			this._photo.src = data.image;
			this._photo.alt = data.imageAlt || "";
			this._photo.parentElement.style.display = "";
		} else {
			this._photo.parentElement.style.display = "none";
		}

		const card = this.modal.querySelector(".info-modal__card");
		this.modal.classList.add("is-open");
		document.body.classList.add("no-scroll");
		gsap.fromTo(this.modal, { opacity: 0 }, { opacity: 1, duration: 0.25, ease: "power2.out" });
		gsap.fromTo(card, { scale: 0.92 }, { scale: 1, duration: 0.35, ease: "back.out(1.7)" });
	}

	close() {
		if (!this.modal) return;
		const card = this.modal.querySelector(".info-modal__card");
		gsap.timeline({ onComplete: () => {
			this.modal.classList.remove("is-open");
			document.body.classList.remove("no-scroll");
			gsap.set(card, { scale: 1 });
		}})
			.to(card, { scale: 0.9, duration: 0.3, ease: "back.in(1.7)" }, 0)
			.to(this.modal, { opacity: 0, duration: 0.25, ease: "power2.in" }, 0);
	}
}

export default InfoModal;
